import moment from 'moment'
import Vue from 'vue'

Vue.filter('number', function (value) {
  const formater = new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 2
  });
  return formater.format(value);
});

Vue.filter('formatDate', function (value) {
    if (value) {
        const temp = moment(value).format('DD-MM-YYYY hh:mm')
        if (temp.toString() === 'Invalid date') {
            return moment.utc(value.toString()).format("DD-MM-YYYY hh:mm")
        } else {
            return temp
        }
    }
})

Vue.filter('date', function (value) {
    if (value) {
        const temp = moment(value).format('DD-MM-YYYY')
        if (temp.toString() === 'Invalid date') {
            return moment.utc(value.toString()).format("DD-MM-YYYY")
        } else {
            return temp
        }
    }
})
